import React from "react";
import PropTypes from "prop-types";

import { ModalView } from "../../../components/simple";
import XandrForm from "../../../components/forms/XandrForm";

const Modal = ({ isShow, onClose, requestAccess, error }) => {
  const handleSubmit = state => {
    requestAccess(state);
  };

  return (
    <ModalView toggle={onClose} handleClose={onClose} isOpen={isShow}>
      {isShow && <XandrForm handleSubmit={handleSubmit} error={error} />}
    </ModalView>
  );
};

Modal.propTypes = {
  isShow: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  requestAccess: PropTypes.func.isRequired,
  error: PropTypes.string
};

Modal.defaultProps = {
  error: ""
};

export default Modal;
